import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  clienteService,
  prestamoService,
  whatsappService,
} from "../../services/api";
import whatsappWebService from "../../services/whatsappWeb";
import "../../styles/WhatsAppEnviar.css";

function EnviarMensaje() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modo, setModo] = useState("individual"); // individual o masivo

  // Estados para envío individual
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [prestamos, setPrestamos] = useState([]);
  const [prestamoSeleccionado, setPrestamoSeleccionado] = useState("");

  // Estados para plantillas
  const [plantillas, setPlantillas] = useState([]);
  const [plantillaSeleccionada, setPlantillaSeleccionada] = useState("");

  // Estados para mensaje
  const [mensaje, setMensaje] = useState("");
  const [preview, setPreview] = useState("");
  const [numeroDestino, setNumeroDestino] = useState("");

  // Estados para envío masivo
  const [filtroMasivo, setFiltroMasivo] = useState("todos"); // todos, activos, vencidos, mora
  const [clientesSeleccionados, setClientesSeleccionados] = useState([]);

  // Estados para programación
  const [enviarInmediato, setEnviarInmediato] = useState(true);
  const [fechaProgramado, setFechaProgramado] = useState("");

  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    cargarDatosIniciales();
  }, []);

  useEffect(() => {
    if (clienteSeleccionado) {
      cargarPrestamosCliente(clienteSeleccionado);
      const cliente = clientes.find(
        (c) => c.id === parseInt(clienteSeleccionado)
      );
      if (cliente) {
        setNumeroDestino(cliente.celular || cliente.telefono || "");
      }
    }
  }, [clienteSeleccionado]);

  useEffect(() => {
    if (plantillaSeleccionada && clienteSeleccionado) {
      generarPreview();
    }
  }, [plantillaSeleccionada, clienteSeleccionado, prestamoSeleccionado]);

  const cargarDatosIniciales = async () => {
    try {
      setLoading(true);
      const [clientesRes, plantillasRes] = await Promise.all([
        clienteService.getClientes(),
        whatsappService.getPlantillas({ activo: "true" }),
      ]);

      console.log("Respuesta clientes:", clientesRes.data);
      console.log("Respuesta plantillas:", plantillasRes.data);

      setClientes(clientesRes.data.clientes || []);
      setPlantillas(plantillasRes.data.plantillas || []);

      if (
        !clientesRes.data.clientes ||
        clientesRes.data.clientes.length === 0
      ) {
        showMessage("warning", "No hay clientes registrados en el sistema");
      }
      if (
        !plantillasRes.data.plantillas ||
        plantillasRes.data.plantillas.length === 0
      ) {
        showMessage(
          "warning",
          "No hay plantillas activas. Ve a Plantillas para crear una"
        );
      }
    } catch (error) {
      console.error("Error cargando datos:", error);
      console.error(
        "Detalles del error:",
        error.response?.data || error.message
      );

      // Si es error de autenticación, no mostrar mensaje (PrivateRoute manejará la redirección)
      if (error.response?.status === 401) {
        return;
      }

      showMessage(
        "error",
        `Error al cargar datos: ${error.response?.data?.error || error.message}`
      );
    } finally {
      setLoading(false);
    }
  };

  const cargarPrestamosCliente = async (clienteId) => {
    try {
      const response = await prestamoService.getPrestamos({
        cliente_id: clienteId,
      });
      setPrestamos(response.data.prestamos || []);
    } catch (error) {
      console.error("Error cargando préstamos:", error);
    }
  };

  const generarPreview = async () => {
    if (!plantillaSeleccionada || !clienteSeleccionado) return;

    try {
      const response = await whatsappService.previewPlantilla(
        plantillaSeleccionada,
        {
          cliente_id: clienteSeleccionado,
          prestamo_id: prestamoSeleccionado || null,
        }
      );
      setPreview(response.data.preview);
      setMensaje(response.data.preview);
    } catch (error) {
      console.error("Error generando preview:", error);
    }
  };

  const handleEnviarIndividual = async (e) => {
    e.preventDefault();

    if (!clienteSeleccionado) {
      showMessage("error", "Selecciona un cliente");
      return;
    }

    if (!mensaje.trim()) {
      showMessage("error", "Escribe un mensaje");
      return;
    }

    try {
      setLoading(true);

      // Obtener datos del cliente
      const cliente = clientes.find(
        (c) => c.id === parseInt(clienteSeleccionado)
      );
      if (!cliente || !cliente.celular) {
        showMessage("error", "Cliente no tiene número de celular registrado");
        return;
      }

      // Usar el nuevo servicio de WhatsApp Web
      const resultado = await whatsappWebService.sendMessage(
        cliente.celular,
        mensaje
      );

      showMessage("success", "✅ " + resultado.message);

      // Limpiar formulario
      setClienteSeleccionado("");
      setMensaje("");
      setPlantillaSeleccionada("");
      setPreview("");
    } catch (error) {
      showMessage("error", "❌ Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEnviarMasivo = async (e) => {
    e.preventDefault();

    if (!plantillaSeleccionada) {
      showMessage("error", "Selecciona una plantilla para envío masivo");
      return;
    }

    if (clientesSeleccionados.length === 0) {
      showMessage("error", "No hay clientes seleccionados");
      return;
    }

    if (
      !window.confirm(
        `¿Enviar mensaje a ${clientesSeleccionados.length} clientes?`
      )
    ) {
      return;
    }

    try {
      setLoading(true);

      // Obtener plantilla seleccionada
      const plantilla = plantillas.find(
        (p) => p.id === parseInt(plantillaSeleccionada)
      );
      if (!plantilla) {
        showMessage("error", "Plantilla no encontrada");
        return;
      }

      // Preparar lista de clientes con números
      const clientesConNumero = clientes.filter(
        (cliente) =>
          clientesSeleccionados.includes(cliente.id) && cliente.celular
      );

      if (clientesConNumero.length === 0) {
        showMessage(
          "error",
          "Ningún cliente seleccionado tiene número de celular"
        );
        return;
      }

      // Usar el nuevo servicio de WhatsApp Web para envío masivo
      const resultado = await whatsappWebService.sendBulkMessage(
        clientesConNumero,
        plantilla.contenido
      );

      showMessage(
        "success",
        `✅ Proceso iniciado para ${clientesConNumero.length} clientes. Se abrirá WhatsApp Web para cada envío.`
      );

      // Limpiar selecciones
      setClientesSeleccionados([]);
      setPlantillaSeleccionada("");
      setFiltroMasivo("todos");
    } catch (error) {
      showMessage("error", "❌ Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFiltroMasivo = (filtro) => {
    setFiltroMasivo(filtro);

    let clientesFiltrados = [];

    switch (filtro) {
      case "todos":
        clientesFiltrados = clientes.map((c) => c.id);
        break;
      case "activos":
        // Clientes con préstamos activos (simulado - ajustar según tu lógica)
        clientesFiltrados = clientes
          .slice(0, Math.floor(clientes.length / 2))
          .map((c) => c.id);
        break;
      case "vencidos":
        // Clientes con préstamos vencidos (simulado)
        clientesFiltrados = clientes
          .slice(Math.floor(clientes.length / 2))
          .map((c) => c.id);
        break;
      default:
        clientesFiltrados = [];
    }

    setClientesSeleccionados(clientesFiltrados);
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: "", text: "" }), 5000);
  };

  if (loading && clientes.length === 0) {
    return (
      <div className="enviar-mensaje-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="enviar-mensaje-page">
      <div className="page-header">
        <div>
          <h1>✉️ Enviar Mensaje</h1>
          <p className="subtitle">
            Envía mensajes individuales o masivos por WhatsApp
          </p>
        </div>
        <button
          onClick={() => navigate("/whatsapp")}
          className="btn btn-secondary"
        >
          ← Volver
        </button>
      </div>

      {message.text && (
        <div className={`message-alert ${message.type}`}>{message.text}</div>
      )}

      {/* Selector de Modo */}
      <div className="mode-selector">
        <button
          className={`mode-btn ${modo === "individual" ? "active" : ""}`}
          onClick={() => setModo("individual")}
        >
          <span className="mode-icon">👤</span>
          <span>Individual</span>
        </button>
        <button
          className={`mode-btn ${modo === "masivo" ? "active" : ""}`}
          onClick={() => setModo("masivo")}
        >
          <span className="mode-icon">👥</span>
          <span>Masivo</span>
        </button>
      </div>

      {/* MODO INDIVIDUAL */}
      {modo === "individual" && (
        <form onSubmit={handleEnviarIndividual} className="enviar-form">
          <div className="form-grid">
            {/* Columna Izquierda - Configuración */}
            <div className="form-column">
              <div className="form-card">
                <h3>📋 Configuración</h3>

                <div className="form-group">
                  <label>Cliente *</label>
                  <select
                    value={clienteSeleccionado}
                    onChange={(e) => setClienteSeleccionado(e.target.value)}
                    required
                  >
                    <option value="">Seleccionar cliente...</option>
                    {clientes.map((cliente) => (
                      <option key={cliente.id} value={cliente.id}>
                        {cliente.nombres} {cliente.apellidos} - {cliente.cedula}
                      </option>
                    ))}
                  </select>
                </div>

                {clienteSeleccionado && (
                  <div className="form-group">
                    <label>Número de Destino</label>
                    <input
                      type="text"
                      value={numeroDestino}
                      readOnly
                      className="input-readonly"
                    />
                  </div>
                )}

                {prestamos.length > 0 && (
                  <div className="form-group">
                    <label>Préstamo (opcional)</label>
                    <select
                      value={prestamoSeleccionado}
                      onChange={(e) => setPrestamoSeleccionado(e.target.value)}
                    >
                      <option value="">Sin préstamo específico</option>
                      {prestamos.map((prestamo) => (
                        <option key={prestamo.id} value={prestamo.id}>
                          #{prestamo.id} - RD${" "}
                          {prestamo.monto?.toLocaleString()} - {prestamo.estado}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="form-group">
                  <label>Plantilla</label>
                  <select
                    value={plantillaSeleccionada}
                    onChange={(e) => setPlantillaSeleccionada(e.target.value)}
                  >
                    <option value="">Mensaje personalizado</option>
                    {plantillas.map((plantilla) => (
                      <option key={plantilla.id} value={plantilla.id}>
                        {plantilla.nombre}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Programación</label>
                  <div className="radio-group">
                    <label>
                      <input
                        type="radio"
                        checked={enviarInmediato}
                        onChange={() => setEnviarInmediato(true)}
                      />
                      <span>Enviar ahora</span>
                    </label>
                    <label>
                      <input
                        type="radio"
                        checked={!enviarInmediato}
                        onChange={() => setEnviarInmediato(false)}
                      />
                      <span>Programar</span>
                    </label>
                  </div>
                </div>

                {!enviarInmediato && (
                  <div className="form-group">
                    <label>Fecha y Hora</label>
                    <input
                      type="datetime-local"
                      value={fechaProgramado}
                      onChange={(e) => setFechaProgramado(e.target.value)}
                      required={!enviarInmediato}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Columna Derecha - Mensaje */}
            <div className="form-column">
              <div className="form-card">
                <h3>💬 Mensaje</h3>

                <div className="form-group">
                  <label>Contenido del Mensaje *</label>
                  <textarea
                    value={mensaje}
                    onChange={(e) => setMensaje(e.target.value)}
                    rows="12"
                    placeholder="Escribe tu mensaje aquí..."
                    required
                  />
                  <small className="char-count">
                    {mensaje.length} caracteres
                  </small>
                </div>

                {preview && (
                  <div className="preview-box">
                    <h4>📱 Preview</h4>
                    <div className="whatsapp-bubble">{preview}</div>
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-success btn-large"
                  disabled={loading}
                >
                  {loading ? "⏳ Enviando..." : "📤 Enviar Mensaje"}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}

      {/* MODO MASIVO */}
      {modo === "masivo" && (
        <form onSubmit={handleEnviarMasivo} className="enviar-form">
          <div className="form-grid">
            {/* Configuración Masiva */}
            <div className="form-column">
              <div className="form-card">
                <h3>👥 Envío Masivo</h3>

                <div className="form-group">
                  <label>Plantilla *</label>
                  <select
                    value={plantillaSeleccionada}
                    onChange={(e) => setPlantillaSeleccionada(e.target.value)}
                    required
                  >
                    <option value="">Seleccionar plantilla...</option>
                    {plantillas.map((plantilla) => (
                      <option key={plantilla.id} value={plantilla.id}>
                        {plantilla.nombre}
                      </option>
                    ))}
                  </select>
                  <small>El envío masivo requiere usar una plantilla</small>
                </div>

                <div className="form-group">
                  <label>Filtrar Clientes</label>
                  <div className="filter-buttons">
                    <button
                      type="button"
                      className={`filter-btn ${
                        filtroMasivo === "todos" ? "active" : ""
                      }`}
                      onClick={() => handleFiltroMasivo("todos")}
                    >
                      Todos ({clientes.length})
                    </button>
                    <button
                      type="button"
                      className={`filter-btn ${
                        filtroMasivo === "activos" ? "active" : ""
                      }`}
                      onClick={() => handleFiltroMasivo("activos")}
                    >
                      Con Préstamos Activos
                    </button>
                    <button
                      type="button"
                      className={`filter-btn ${
                        filtroMasivo === "vencidos" ? "active" : ""
                      }`}
                      onClick={() => handleFiltroMasivo("vencidos")}
                    >
                      Con Préstamos Vencidos
                    </button>
                  </div>
                </div>

                <div className="clientes-count">
                  <strong>{clientesSeleccionados.length}</strong> clientes
                  seleccionados
                </div>

                <div className="warning-box">
                  ⚠️ <strong>Importante:</strong>
                  <ul>
                    <li>
                      Se enviará el mismo mensaje a todos los clientes
                      seleccionados
                    </li>
                    <li>
                      Las variables se reemplazarán automáticamente por cada
                      cliente
                    </li>
                    <li>Verifica la plantilla antes de enviar</li>
                  </ul>
                </div>

                <button
                  type="submit"
                  className="btn btn-success btn-large"
                  disabled={loading || clientesSeleccionados.length === 0}
                >
                  {loading
                    ? "⏳ Enviando..."
                    : `📤 Enviar a ${clientesSeleccionados.length} Clientes`}
                </button>
              </div>
            </div>

            {/* Preview Masivo */}
            <div className="form-column">
              <div className="form-card">
                <h3>📝 Plantilla Seleccionada</h3>

                {plantillaSeleccionada ? (
                  <>
                    {plantillas.find(
                      (p) => p.id === parseInt(plantillaSeleccionada)
                    ) && (
                      <div className="plantilla-preview">
                        <h4>
                          {
                            plantillas.find(
                              (p) => p.id === parseInt(plantillaSeleccionada)
                            ).nombre
                          }
                        </h4>
                        <div className="plantilla-content">
                          {
                            plantillas.find(
                              (p) => p.id === parseInt(plantillaSeleccionada)
                            ).contenido
                          }
                        </div>
                        <div className="plantilla-vars">
                          <strong>Variables disponibles:</strong>
                          <div className="vars-list">
                            {plantillas
                              .find(
                                (p) => p.id === parseInt(plantillaSeleccionada)
                              )
                              .variables?.map((v, i) => (
                                <span
                                  key={i}
                                  className="var-tag"
                                >{`{${v}}`}</span>
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="empty-state">
                    <p>Selecciona una plantilla para ver el preview</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default EnviarMensaje;
